import { Divider, Typography } from 'antd'
import React from 'react'
import BinMaster from '../../../components/GSuperMarket/BinMaster/BinMaster'

const GSM_MasterBinPage = () => {
  return (
    <>
            <div
                style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                }}
            >
                <Typography.Title
                    level={5}
                    style={{
                        margin: 0,
                    }}
                >
                    Master Bin
                </Typography.Title>
            </div>
            <Divider style={{ marginTop: 8 }} />
            <BinMaster />        
        </>
  )
}

export default GSM_MasterBinPage